<template>
  <div class="test-reservation-wrap">
    <div>
      <div class="my-breadcrumb pdb20" v-if="step == 1">
        <span>我的位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/user/index' }">{{ product.model_name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ product.category_name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ product.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="reservation-info" v-if="step == 1">
        <div class="my-card-title">预约须知</div>
        <div class="content" v-html="product.knowledge"></div>
      </div>
      <div class="reservation-step">
        <div class="my-step">
          <div class="step-icon step-icon-sel">1</div>
          <p class="step-name step-name-sel">下单：{{ product.name }}</p>
          <img src="~@/assets/images/step_next_icon.png" class="step-arrow" alt="">
          <div :class="['step-icon', { 'step-icon-sel': step >= 2 }]">2</div>
          <p :class="['step-name', { 'step-name-sel': step >= 2 }]">附加信息</p>
          <img src="~@/assets/images/step_next_icon.png" class="step-arrow" alt="">
          <div :class="['step-icon', { 'step-icon-sel': step >= 3 }]">3</div>
          <p :class="['step-name', { 'step-name-sel': step >= 3 }]">支付订单</p>
        </div>
        <el-form autoComplete="on" element-loading-text="给我一点时间" size="small" label-position="right" ref="form"
          :model="form" label-width="200px" label-suffix="：" :rules="formRules">
          <div class="step-form-card" v-if="step == 1">
            <div class="form-header">
              <div class="sample-list">
                <div v-for="(sample, index) in form.content" :key="index"
                  :class="['sample', { 'sample-sel': currentIndex == index }]" @click="currentIndex = index">
                  <span>{{ sample.name }}</span><span class="close" @click="deleteItem(index)">×</span>
                </div>
              </div>
              <button type="button" class="my-btn addItem" @click="addItem">新增{{ groupName }}</button>
            </div>

            <div v-for="(sample, sampleIdx) in form.content" :key="sampleIdx">
              <div class="my-form" v-if="currentIndex == sampleIdx">
                <template v-if="product.group == 'project'">
                  <el-form-item label="样品数量" :prop="'content.' + sampleIdx + '.count'" required :show-message="false">
                    <div class="flex-col">
                      <el-input-number v-model="sample.count" style="width:150px;" controls-position="right"
                        placeholder="请输入样品数量" clearable @change="sampleCountChange(sampleIdx)" :min="1"
                        :max="99"></el-input-number>
                      <p class="form-text form-text-red"> 如果存在多组不同类型的样品，一定要分组预约（A/B/C等组）。</p>
                    </div>
                  </el-form-item>

                  <el-form-item label="样品编号" :prop="'content.' + sampleIdx + '.code'" required :show-message="false">
                    <div class="flex-col">
                      <el-input type="text" v-model="sample.code" placeholder="请输入样品编号" clearable>
                      </el-input>
                      <p class="form-text form-text-red"> 请输入该组样品编号-名称，以逗号分隔，例如1-C1，2-N2，3-D3。</p>
                    </div>
                  </el-form-item>
                </template>
                <template v-for="(form, index) in sample.formList">
                  <el-form-item v-if="formList[sampleIdx].includes(form.uuid)" :label="form.config.name"
                    :key="`${sampleIdx}_${index}_${form.id}_${form.type}`"
                    :prop="`content.${sampleIdx}.formList.${index}.value`" :required="form.config.required" :rules="[
        { required: form.config.required, message: '请' + (['images', 'image', 'file'].includes(form.type) ? '上传' : ['input', 'textarea', 'number'].includes(form.type) ? '输入' : '选择') + sample.name + form.config.name, trigger: 'blur' },
      ]" :show-message="false">
                    <div class="flex-col full-width">
                      <component :is="`form-${form.type}`" v-model="form.value" :config="form.config"></component>
                      <p class="form-text form-text-red" v-if="form.config.tips">提示：{{ form.config.tips }}</p>
                    </div>
                  </el-form-item>
                </template>
              </div>
            </div>

          </div>
          <div class="attr-info" v-if="step == 2">

            <div class="my-form">

              <el-form-item label="是否加急">
                <el-radio-group v-model="form.urgent">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="样品回收" v-if="product.group == 'project'">
                <div class="flex-col">
                  <el-radio-group v-model="form.recovery">
                    <el-radio :label="0">不回收</el-radio>
                    <el-radio :label="1">回收</el-radio>
                  </el-radio-group>
                  <div class="form-text form-text-red"> 样品在实验室一般保留3个工作日，若数据有疑问需尽快反馈，以便及时处理。</div>
                </div>
              </el-form-item>
              <el-form-item label="订单类型">
                <div class="flex-col">
                  <el-radio-group v-model="form.type">
                    <el-radio :label="0">个人订单</el-radio>
                    <el-radio :label="1">团队订单</el-radio>
                  </el-radio-group>
                  <div class="form-text form-text-red"> 如选择团队订单则需要团长审核通过。</div>
                </div>
              </el-form-item>

              <el-form-item label="联系人" prop="linkman" :show-message="false">
                <div class="flex-col">
                  <el-input type="text" style="width:350px" v-model="form.linkman" placeholder="请输入联系人">
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="联系人电话" prop="linknum" :show-message="false">
                <div class="flex-col">
                  <el-input type="text" style="width:350px" v-model="form.linknum" placeholder="请输入联系电话">
                  </el-input>
                </div>
              </el-form-item>
              <template v-if="product.group == 'project'">
                <el-form-item label="同设备订单">
                  <div class="flex-col">
                    <el-radio-group v-model="form.same_device">
                      <el-radio :label="0">不需要</el-radio>
                      <el-radio :label="1">需要</el-radio>
                    </el-radio-group>
                    <div class="form-text form-text-red"> 与之前的测试同设备</div>
                  </div>
                </el-form-item>

                <el-form-item v-if="form.same_device == 1" label="选择订单" prop="same_order" :show-message="false">
                  <div class="flex-col">
                    <order-select v-model="form.same_order" :productId="productId"></order-select>
                  </div>
                </el-form-item>


                <el-form-item label="送样方式">
                  <div class="flex-col">
                    <el-radio-group v-model="form.sample_type">
                      <el-radio :label="0">邮寄样品</el-radio>
                      <!-- <el-radio :label="1">上门取样</el-radio>
                  <el-radio :label="2">自己送样</el-radio> -->
                    </el-radio-group>
                    <div class="form-text form-text-red"> {{ trade.sample_type_tips }}</div>
                  </div>
                </el-form-item>
              </template>

              <div v-if="form.sample_type == 1000" class="sampleSendType1">
                <p class="title">样品寄送地址</p>
                <div class="address-list">
                  <div v-for="(item, idx) in officeList" @click="form.office_id = item.id"
                    :class="['item', { 'active': form.office_id == item.id }]" :key="idx">{{ item.name
                    }}
                  </div>
                </div>
                <div class="active-address-detail">
                  <p>{{ currentOffice.province }}{{ currentOffice.city }}{{ currentOffice.district }}</p>
                  <p>{{ currentOffice.detail }}</p>
                  <p class="fwb">联系老师：{{ currentOffice.recipient_name }}</p>
                  <p class="fwb">联系电话：{{ currentOffice.recipient_phone }}</p>
                </div>
              </div>
              <div v-if="form.sample_type == 1" class="sampleSendType2">
                <el-form-item label="取样地址" prop="areaArr" :show-message="false">
                  <el-cascader style="width:350px;" v-model="form.areaArr" placeholder="请选择地址" clearable
                    :props="cascaderProp" :options="areaList">
                  </el-cascader>
                </el-form-item>

                <el-form-item label="详细地址" prop="sample_detail" :show-message="false">
                  <el-input type="text" style="width:350px" v-model="form.sample_detail" placeholder="请输入详细地址">
                  </el-input>
                </el-form-item>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="联系人" prop="sample_linkman" :show-message="false">
                      <el-input type="text" style="width:220px" v-model="form.sample_linkman" placeholder="请输入上门取样联系人">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话" prop="sample_linknum" :show-message="false">
                      <el-input type="text" style="width:220px" v-model="form.sample_linknum" placeholder="请输入上门取样联系电话">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="取样时间" prop="sample_reserve_time" :show-message="false">
                  <el-date-picker v-model="form.sample_reserve_time" type="datetime" placeholder="选择取样时间">
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
        <div class="wait-pay-info" v-if="step == 3">
          <div class="my-card-title">待支付详情</div>
          <div class="content">
            <div class="cost-list">
              <div class="title">{{ product.name }}</div>
              <div class="cost-item">
                <span>订单费用</span>
                <span>￥{{ orderAmount }}</span>
              </div>
              <div class="cost-item" v-if="couponList.length > 0">
                <span>优惠券</span>
                <el-popover placement="bottom" v-model="showCouponPicker" width="200px" trigger="click">
                  <el-radio-group v-model="form.user_coupon_id" @change="couponChange">
                    <el-radio v-for="(item, idx) in couponList" class="mgb5" style="display: block;" :key="idx"
                      :label="item.id" :value="item.id"><span class="colorRed">-￥{{
        item.price }}{{ item.name }}</span></el-radio>
                  </el-radio-group>
                  <span style="color: #FF6666;" slot="reference">
                    {{ form.user_coupon_id == 0 ? '有' + couponList.length + '张可用优惠券' : '-￥' + form.coupon_price }}
                  </span>
                </el-popover>
              </div>
              <div class="cost-total">
                <span>合计费用</span>
                <span style="color: #FF6666;"> ￥{{ payAmount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pay-type" v-if="step == 3" style="display:none;">
          <div class="my-card-title">支付方式</div>
          <div class="pay-type-wrap">
            <div class="pay-type-title">
              <p>预存支付</p>
              <div class="tip">余额：￥0</div>
            </div>
            <div class="form-check under-line">
              <input class="form-check-input" type="radio" name="pay-type" id="pay-type0" value="0"
                v-model="form.payType">
              <label class="form-check-label custom-label" for="pay-type0">
                <img src="~@/assets/images/balance_pay.png" alt="">个人预存余额<span class="tip"
                  style="margin-left: 15px;">您还没有预存，预存可以一次开票、多次使用，省去每次开票的麻烦！<a href="~@/assets/mine/recharge.html"
                    target="_blank"><i>立即预存</i></a></span>
              </label>
            </div>
            <div class="pay-type-title">
              <p>其他方式</p>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="pay-type" id="pay-type1" value="1"
                v-model="form.payType">
              <label class="form-check-label custom-label" for="pay-type1">
                <img src="~@/assets/images/wx_pay.png" alt="">微信支付
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="pay-type" id="pay-type2" value="2"
                v-model="form.payType">
              <label class="form-check-label custom-label" for="pay-type2">
                <img src="~@/assets/images/ali_pay.png" alt="">支付宝支付
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="pay-type" id="pay-type3" value="3"
                v-model="form.payType">
              <label class="form-check-label custom-label" for="pay-type3">
                <img src="~@/assets/images/credit_pay.png" alt="">信用金支付<span class="tip"
                  style="margin-left: 15px;">0元下单，先测试后付款，
                  快去<a href="~@/assets/mine/index.html?sideBar=1" target="_blank"><i>实名认证</i></a> ，领取你的5000元信用额度</span>
              </label>
            </div>
            <div style="margin-top: 40px;" v-if="form.payType == 3 || form.payType == 0">
              <div class="pay-type-title">
                <p>支付密码</p>
              </div>
              <div class="pay-password">
                <div class="password-inp">
                  <el-input type="password" style="width:200px" v-model="form.password" placeholder="请输入支付密码">
                  </el-input>
                  <i @click="resetPayPassword">忘记密码？</i>
                </div>
                <div class="tip">请输入6位数字支付密码</div>
              </div>
            </div>
          </div>
        </div>
        <div class="settlement-wrap">
          <div class="cost">
            <template v-if="product.baojia_tips">
              <span class="baojia-tips">{{ product.baojia_tips }}</span>
            </template>
            <template v-else>
              <span class="cost-title">合计费用：</span><span class="cost-num">￥{{ payAmount }}</span>
              <el-popover placement="top" width="400" trigger="click">
                <div class="dropdown">
                  <div class="dropdown-menu">
                    <p class="test-name">{{ product.name }}</p>
                    <p class="test-item" v-for="item in priceList" :key="item.name">
                      <span class="test-item-name">{{ item.name }}</span>
                      <span class="test-item-num">￥{{ item.price }}X{{ item.count }}</span>
                    </p>
                    <p class="test-item colorRed" v-if="form.user_coupon_id > 0">
                      <span class="test-item-name">优惠券</span>
                      <span class="test-item-num">-￥{{ form.coupon_price }}</span>
                    </p>
                    <p class="total-cost">
                      <span class="total-cost-title">合计费用</span>
                      <span class="total-cost-num">￥{{ payAmount }}</span>
                    </p>
                  </div>
                </div>
                <span class="cost-detail" slot="reference">
                  费用明细
                </span>
              </el-popover>
            </template>

          </div>
          <div class="btns" v-if="!preview">
            <el-button class="save-btn" v-if="step == 1" :loading="loading" @click="handleNextStep(1)">保存草稿</el-button>
            <el-button class="save-btn" v-if="step != 1" @click="handlePrevStep()">上一步</el-button>
            <el-button class="next-btn" v-if="step != 3" @click="handleNextStep(0)">下一步</el-button>
            <el-button class="next-btn" v-if="step == 3" :loading="loading" @click="handleAddOrder()">确认并支付</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 重置支付密码 -->
    <ResetPayPassword :visible.sync="showResetPayPasswordForm" />
    <!-- 预约须知 -->
    <knowledge :visible.sync="showKnowledgeForm" :name="product.name" :content="product.knowledge" />
    <!-- 协议 -->
    <agreement :visible.sync="showAgreementForm" alias="responsibility" @success="checked = true" />
    <!-- 付款二维码 -->
    <pay-qrcode :pay="pay" :visible.sync="showQrcodeForm" />

  </div>
</template>

<script>
import { equal } from "@/utils"
import { getOrderPreview, addOrder, getCouponList } from "@/api/order";
import { getAreaTree, getAllOfficeList, getConfig } from "@/api/common";
import PayQrcode from '@/components/payQrcode';
import Knowledge from './components/knowledge';
import Agreement from './components/agreement';
import ResetPayPassword from '@/components/resetPayPassword';
import OrderSelect from '@/components/orderSelect';
import FormInput from '@/components/form/input' //文本框
import FormTextarea from '@/components/form/textarea' //多行文本
import FormRadio from '@/components/form/radio' //单选框
import FormCheckbox from '@/components/form/checkbox' //多选框
import FormSelect from '@/components/form/select' //下拉框
import FormImage from '@/components/form/image' //单图上传
import FormImages from '@/components/form/images' //多图上传
import FormFile from '@/components/form/file' //文件上传
import FormDate from '@/components/form/date' //日期
import FormDatetime from '@/components/form/datetime' //日期时间
import FormTime from '@/components/form/time' //时间
import FormNumber from '@/components/form/number' //数字输入框
import FormSample from '@/components/form/sample' //上传模版

export default {
  name: "OrderProjectAdd",
  components: {
    PayQrcode,
    Knowledge,
    Agreement,
    ResetPayPassword,
    OrderSelect,
    FormInput,
    FormTextarea,
    FormRadio,
    FormCheckbox,
    FormSelect,
    FormImage,
    FormImages,
    FormFile,
    FormDate,
    FormDatetime,
    FormTime,
    FormNumber,
    FormSample
  },
  props: {},
  data() {
    // 自定义验证规则，检查对象是否为空
    var checkObject = (rule, value, callback) => {
      if (Object.keys(value).length === 0) {
        callback(new Error('请选择同设备订单！'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      form: {
        sample_type: 0,
        type: 0,
        office_id: 0,
        payType: 0,
        urgent: 0,
        same_device: 0,
        same_order: {},
        linkman: null,
        linknum: null,
        user_coupon_id: 0,
        coupon_price: 0,
        recovery: 0,
        areaArr: [],
        sample_detail: '',
        sample_linkman: '',
        sample_linknum: '',
        sample_reserve_time: null,
        //样品数据
        content: []
      },
      trade: {},
      pay: {},
      areaList: [],
      cascaderProp: {
        value: 'id',
        label: 'name',
        children: '_child',
        disabled: 'disabled'
      },
      showKnowledgeForm: false,
      showAgreementForm: true,
      showQrcodeForm: false,
      showResetPayPasswordForm: false,
      officeList: [],
      couponList: [],
      showCouponPicker: false,
      step: 1,
      currentIndex: 0,
      letters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      initFormList: [],
      productId: 0,
      draftId: 0,
      product: {
        knowledge: null
      },
      formRules: {
        linkman: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        linknum: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
        ],
        same_order: [
          { required: true, validator: checkObject, trigger: 'blur' }
        ],
        areaArr: [
          { required: true, message: '请选择上门取样地址', trigger: 'blur' }
        ],
        sample_detail: [
          { required: true, message: '请输入上门取样地址', trigger: 'blur' },
        ],
        sample_linkman: [
          { required: true, message: '请输入上门取样联系人', trigger: 'blur' },
        ],
        sample_linknum: [
          { required: true, message: '请输入上门取样联系电话', trigger: 'blur' },
        ],
        sample_reserve_time: [
          { required: true, message: '请选择取样时间', trigger: 'blur' },
        ],
      },
      preview: 0
    }
  },
  computed: {
    debug() {
      return process.env.NODE_ENV === "production" ? false : true
    },
    groupName() {
      return this.product.group == 'project' ? '实验样品' : '需求'
    },
    currentOffice() {
      return this.form.office_id > 0 ? this.officeList.find(item => { return item.id == this.form.office_id }) : {}
    },
    orderAmount() {
      let amount = 0;
      for (let i = 0; i < this.form.content.length; i++) {
        let sample = this.form.content[i];
        for (let j = 0; j < sample.formList.length; j++) {
          let form = sample.formList[j];
          //&& this.formList[i].includes(form.uuid)
          if (['radio', 'select', 'checkbox'].includes(form.type)) {
            const priceArr = form.config.list.filter(item => equal(form.value, item.name)).map(item => parseFloat(item.price * sample.count));
            if (priceArr.length > 0) amount += priceArr.length == 1 ? priceArr[0] : priceArr.reduce((a, b) => a + b)
          } else if (form.type == 'number') {
            amount += parseFloat(form.config.price * sample.count) * parseFloat(form.value || 0)
          }
          // console.log(form, amount)
        }
      }
      if (this.form.urgent && this.product.urgent_ratio > 1) {
        amount += parseFloat(amount * (this.product.urgent_ratio - 1))
      }
      if (this.form.recovery && this.product.recovery_price > 0) {
        amount += parseFloat(this.product.recovery_price)
      }
      return amount.toFixed(2);
    },
    formList() {
      let formList = [];
      for (let i = 0; i < this.form.content.length; i++) {
        let sample = this.form.content[i];
        let all = [];
        let allName = [];
        let logic = [];
        let logicName = [];
        let select = [];
        let selectName = [];
        for (let j = 0; j < sample.formList.length; j++) {
          let form = sample.formList[j];
          all.push(form.uuid);
          allName.push(form.config.name);
          if (['radio', 'select', 'checkbox'].includes(form.type)) {
            form.config.list.filter(item => item.logic.length > 0).map(item => {
              logic = logic.concat(item.logic)
              logicName = logicName.concat(item.name)
            })
            form.config.list.filter(item => equal(form.value, item.name) && item.logic.length > 0).map(item => {
              select = select.concat(item.logic)
            })
          }
        }
        const formArr = all.filter(item => !logic.includes(item)).concat(select);
        this.form.content[i]['formList'] = sample.formList.map((item) => {
          if (formArr.includes(item.uuid)) {
            return item
          } else {
            const initFormList = JSON.parse(JSON.stringify(this.initFormList))
            console.log(item.config.name, initFormList.find(init => {
              return init.uuid == item.uuid
            }).value)
            return initFormList.find(init => {
              return init.uuid == item.uuid
            })
          }
        })
        formList[i] = formArr;
      }
      console.log(formList)
      return formList;
    },
    payAmount() {
      return (parseFloat(this.orderAmount) - parseFloat(this.form.coupon_price)).toFixed(2);
    },
    priceList() {
      let nameArr = [];

      for (let i = 0; i < this.form.content.length; i++) {
        let sample = this.form.content[i];
        for (let j = 0; j < sample.formList.length; j++) {
          let form = sample.formList[j];
          if (['radio', 'select', 'checkbox'].includes(form.type)) {
            form.config.list.filter(item => equal(form.value, item.name)).forEach(option => {
              const findIndex = nameArr.findIndex(item => item.name == option.name);
              if (findIndex > -1) {
                nameArr[findIndex]['count']++;
              } else {
                nameArr.push({
                  name: option.name,
                  count: 1,
                  price: parseFloat(option.price).toFixed(2)
                });
              }
            });
          } else if (form.type == 'number' && form.value > 0) {
            const findIndex = nameArr.findIndex(item => item.name == form.config.name);
            if (findIndex > -1) {
              nameArr[findIndex]['count'] += form.value;
            } else {
              nameArr.push({
                name: form.config.name,
                count: form.value,
                price: parseFloat(form.config.price).toFixed(2),
              });
            }
          }
        }
      }
      if (this.form.urgent && this.product.urgent_ratio > 1) {
        let urgentPrice = nameArr.map(item => item.price * item.count).reduce((acc, num) => acc + num, 0);
        nameArr.push({
          name: '加急费',
          count: 1,
          price: parseFloat(urgentPrice * (this.product.urgent_ratio - 1)).toFixed(2)
        })
      }
      if (this.form.recovery && this.product.recovery_price > 0) {
        nameArr.push({
          name: '回收费',
          count: 1,
          price: parseFloat(this.product.recovery_price).toFixed(2)
        })
      }
      return nameArr;
    }
  },
  watch: {
    orderAmount(newValue, oldValue) {
      if (newValue > oldValue) {
        // this.$message.success('金额增加：' + parseFloat(newValue - oldValue).toFixed(2))
      }
    },
    priceList(newValue, oldValue) {
      // console.log(newValue, oldValue)
    },
    step(newValue, oldValue) {
      if (newValue == 1 || newValue == 2) {

      }
    }
  },
  mounted() {
    this.formatPrice = this.utils.formatPrice
  },
  created() {
    this.productId = this.$route.query.id;
    this.draftId = this.$route.query.draft_id;
    this.preview = this.$route.query.preview || 0;
    if (this.debug || this.preview) this.showAgreementForm = true
    // this.getAreaTree()
    // this.getAllOfficeList()
    this.getConfig()
    this.getOrderPreview()
  },
  methods: {
    getConfig() {
      getConfig({ group: 'trade' }).then((res) => {
        this.trade = res.data
      }).catch((err) => {
        console.log(err);
      })
    },
    couponChange(e) {
      this.showCouponPicker = false;
      this.form.coupon_price = parseFloat(this.couponList.filter(item => item.id == e)[0]['price']).toFixed(2);
      console.log(e)
    },
    getCouponList() {
      getCouponList({ model: this.product.model, order_amount: this.orderAmount }).then(res => {
        this.couponList = res.data;
      })
    },
    getAllOfficeList() {
      getAllOfficeList({}).then(res => {
        this.officeList = res.data;
        this.form.office_id = res.data ? res.data[0].id : 0;
      })
    },
    getAreaTree() {
      getAreaTree({}).then(res => {
        this.areaList = res.data;
      })
    },
    handlePrevStep() {
      this.step--;
    },
    handleNextStep(is_draft) {
      this.$refs.form.validate((valid, error) => {
        if (valid) {
          if (is_draft) {
            this.handleAddOrder(is_draft);
          } else {
            if (this.step == 2) {
              this.getCouponList();
            }
            this.step++;
          }
        } else {
          console.log(error)
          Object.values(error).forEach((item, index) => {
            setTimeout(() => {
              this.$message.error(item[0]['message']);
            }, 200 * index)
          })
        }
      })
    },
    sampleCountChange(index) {
      this.form.content.forEach((item, idx) => {
        if (index == idx) {
          const code = []
          for (let i = 0; i < item.count; i++) {
            code.push(i + 1)
          }
          item.code = code.join(',')
          return item;
        }
      })
    },
    getOrderPreview() {
      getOrderPreview({ product_id: this.productId, preview: this.preview, draft_id: this.draftId }).then(res => {
        this.product = res.data.productList[0];
        // this.product.group = 'service'      
        this.initFormList = JSON.parse(JSON.stringify(res.data.initFormList))
        if (this.draftId && res.data.content.length > 0) {
          this.form.content = res.data.content
        } else {
          this.addItem()
          // this.form.content[0].formList = JSON.parse(JSON.stringify(this.initFormList))
        }
      })
    },
    deleteItem(index) {
      if (this.form.content.length == 1) {
        return this.$message.error('至少保留一组' + this.groupName + '!')
      }
      if (index == this.form.content.length - 1 && index == this.currentIndex) {
        this.currentIndex = 0
      }
      this.form.content.splice(index, 1)
    },
    addItem() {
      const name = this.product.group == 'project' ? this.letters[this.form.content.length] + '组' + this.groupName : (this.groupName + this.letters[this.form.content.length]);
      this.form.content.push({
        name: name,
        count: 1,
        code: 1,
        formList: JSON.parse(JSON.stringify(this.initFormList))
      })
      this.currentIndex = this.form.content.length - 1
    },

    // 提交订单
    handleAddOrder(is_draft) {
      const _form = JSON.parse(JSON.stringify(this.form));
      _form.product_id = this.productId;
      _form.group = this.product.group;
      _form.model = this.product.model;
      _form.draft_id = this.draftId;
      _form.same_order_id = Object.keys(_form.same_order).length > 0 ? _form.same_order.id : 0;
      // if (this.form.sample_type == 0) {
      //   if (!_form.office_id) {
      //     this.$message.error('请选择选择寄送地址!')
      //     return
      //   }
      // } else {
      //   _form.office_id = 0
      // }
      if (is_draft) _form.user_coupon_id = 0
      this.loading = true;
      _form.is_draft = is_draft
      addOrder(_form).then((res) => {
        this.loading = false;
        // 弹出操作提示     
        if (is_draft) {
          this.$message.success('加入草稿箱成功!')
        } else {
          if (res.data.pay_amount > 0) {
            this.$message.success('下单成功，正在为您跳转。。。');
            this.$router.push({
              path: '/cashier',
              query: {
                order_id: res.data.id,
                type: 0,
              }
            });
          } else {
            if (this.product.baojia_tips) {
              this.$alert(this.product.baojia_tips, '提示', {
                confirmButtonText: '我知道了',
                callback: action => {
                  this.$router.push({
                    path: '/user/index',
                  });
                }
              });
            } else {
              this.$message.success('下单成功，请等待工程师为您报价!'), setTimeout(() => {
                this.$router.push({
                  path: '/user/index',
                });
              }, 1000);
            }
          }
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    resetPayPassword() {
      this.showResetPayPasswordForm = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.test-reservation-wrap {
  width: 100%;
  background-color: #F4F8F9;
  display: grid;
  grid-template-columns: 940px 242px;
  column-gap: 17px;
  padding-top: 30px;
  justify-content: center;

  .reservation-info {
    width: 100%;
    background-color: white;
    margin-bottom: 20px;

    .content {
      font-size: 14px;
      font-weight: 400;
      color: #343A40;
      line-height: 25px;
      padding: 21px 31px 30px 43px;
    }
  }

  .reservation-step {
    // padding-top: 20px;
    padding-bottom: 283px;

    .step-form-card {
      margin-top: 7px;

      .form-header {
        width: 100%;
        padding: 15px 17px 15px 43px;
        box-sizing: border-box;
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        background-color: white;
        border-bottom: 1px solid #a7acb22e;

        .addItem {
          border-radius: 5px;
          padding: 8px 20px;
          min-width: fit-content;
        }

        .sample-list {
          display: flex;
          column-gap: 28px;
          row-gap: 10px;
          flex-wrap: wrap;

          .sample {
            font-size: 20px;
            font-weight: bold;
            color: #222222;
            cursor: pointer;

            .close {
              color: #A0A9AC !important;
              margin-left: 22px;
              cursor: pointer;
            }
          }

          .sample-sel {
            color: #00B4E8 !important;

            .close {
              color: #00B4E8 !important;
            }
          }
        }
      }

      .my-form {
        width: 100%;
        background: #ffffff;
        padding: 16px 97px 36px 43px;
        box-sizing: border-box;


        .form-text-red {
          color: #FF6666;
          font-size: 10px;
          font-weight: 400;
          line-height: 20px;
          margin-top: 5px;
        }
      }
    }

    .attr-info {
      margin-top: 7px;

      .my-form {
        width: 100%;
        background: #ffffff;
        padding: 36px 97px 36px 43px;
        box-sizing: border-box;

        .form-item {
          grid-template-columns: 3fr 13fr;

          label {
            line-height: 45px;
          }
        }

        .form-text-red {
          color: #FF6666;
          font-size: 10px;
          font-weight: 400;
          margin-top: 5px;
          line-height: 20px;
        }

        .sampleSendType1 {
          padding-top: 10px;
          border-top: 1px solid #CCD7DB;
          padding-left: 120px;

          .title {
            font-size: 14px;
            font-weight: 300;
            color: #222222;
          }

          .address-list {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-top: 10px;

            .item {
              padding: 5px 8px;
              font-size: 14px;
              font-weight: 300;
              color: #A0A9AC;
              border-radius: 4px;
              border: 1px solid #CCD7DB;
              cursor: pointer;
            }

            .active {
              background: #00B4E8;
              color: white;
              border: none;
            }
          }

          .active-address-detail {
            width: 100%;
            padding: 23px 22px;
            box-sizing: border-box;
            font-size: 14px;
            color: #333333;
            line-height: 28px;
            background: #F4F8F9;
            margin-top: 10px;
            border-radius: 4px;
          }
        }

        .sampleSendType2 {
          display: flex;
          flex-direction: column;
          padding-top: 20px;
          border-top: 1px solid #CCD7DB;
          padding-left: 0px;
        }
      }
    }

    .settlement-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;
      width: 900px;
      user-select: none;
      position: sticky;
      bottom: 20px;
      background: #FFF;
      padding: 20px;
      z-index: 999;

      .cost {
        padding-left: 43px;

        .cost-title {
          color: #6F7F84;
          font-size: 16px;
        }

        .cost-num {
          color: #FF6666;
          font-weight: bold;
          font-size: 24px;
        }

        .baojia-tips {
          color: #FF6666;
          font-weight: bold;
          font-size: 18px;
        }

        .cost-detail {
          font-size: 16px;
          font-weight: 400;
          color: #00B4E8;
          margin-left: 39px;
          cursor: pointer;

          span {
            font-weight: 100;
            transition: transform 0.3s ease-in-out;
          }

          span.rotate {
            /* 旋转后的状态 */
            transform: rotate(180deg);
          }
        }

      }

      .btns {
        display: flex;
        align-items: center;
        column-gap: 25px;

        .save-btn {
          padding: 11px 40px;
          border-radius: 25px;
          border: 1px solid #A0A9AC;
          background: #F4F8F9;
          font-size: 20px;
          font-weight: 400;
          color: #222222;
          cursor: pointer;
        }

        .next-btn {
          padding: 11px 40px;
          border-radius: 25px;
          font-size: 20px;
          font-weight: 400;
          color: #FFFFFF;
          background: #00B4E8;
          cursor: pointer;
        }
      }
    }

    .wait-pay-info {
      margin-top: 7px;

      .content {
        padding: 15px 20px 59px 20px;
        box-sizing: border-box;
        width: 100%;
        background: #ffffff;

        .cost-list {
          background: #F4F8F9;
          border-radius: 4px;
          padding: 21px 22px 40px 22px;
          width: 100%;
          box-sizing: border-box;

          .title {
            width: 100%;
            font-size: 16px;
            font-weight: bold;
            color: #222222;
            padding-bottom: 17px;
            border-bottom: 1px solid #CCD7DB;
            box-sizing: border-box;
          }

          .cost-item {
            width: 100%;
            padding: 15px 0;
            border-bottom: 1px solid #CCD7DB;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
          }

          .cost-total {
            font-size: 16px;
            font-weight: bold;
            color: #222222;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 31px;
          }
        }
      }
    }

    .pay-type {
      margin-top: 20px;

      .pay-type-wrap {
        width: 100%;
        padding: 25px 42px 49px 42px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        background-color: #FFFFFF;

        .pay-type-title {
          display: flex;
          align-items: center;
          column-gap: 35px;
          margin-bottom: 9px;
        }

        .tip {
          font-size: 14px;
          font-weight: 300;
          color: #A0A9AC;

          i {
            color: #00B4E8;
          }
        }

        .under-line {
          border-bottom: 1px solid #a7acb22c;
          margin-bottom: 15px;
        }

        .pay-password {
          .password-inp {
            display: flex;
            align-items: center;
            column-gap: 20px;
            margin-bottom: 10px;

            i {
              color: #00B4E8;
              cursor: pointer;
            }
          }
        }

        .form-check {
          display: grid;
          grid-template-columns: 18px auto;
          align-items: center;
          column-gap: 0;
          line-height: initial;
          padding: 9px 0;

          .custom-label {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 300;
            color: #333333;

            &>img {
              width: 30px;
              height: 30px;
              margin-left: 20px;
              margin-right: 20px;
            }
          }

          .total-num {
            text-align: end;
            font-size: 14px;
            font-weight: 300;
            color: #222222;

            i {
              font-size: 14px;
              font-weight: bold;
              color: #FF6666;
            }
          }
        }
      }
    }
  }

}



.dropdown-menu {
  margin-top: 10px;
  background: #FFFFFF;
  padding: 18px 27px 27px 40px;
  box-sizing: border-box;

  .test-name {
    font-size: 16px;
    font-weight: bold;
    color: #222222;
    margin-bottom: 15px;
  }

  .test-item {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .total-cost {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;

    .total-cost-title {
      font-size: 16px;
      font-weight: bold;
      color: #222222;
    }

    .total-cost-num {
      font-size: 20px;
      font-weight: bold;
      color: #FF6666;
    }
  }
}

.el-form-item {
  margin-bottom: 10px;
  display: flex;

  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
    width: 100%;
    margin-left: 0px !important;

    .full-width {
      width: 100%;
    }
  }
}
</style>
